import logo from './logo.svg';
import './App.css';
import DonationSlider from './pages/DonationSlider'; // Use PascalCase

function App() {
  return (
    <DonationSlider /> 
  );
}

export default App;
